import { projectToCRS } from "@nova/calculate-geospatial"
import { Point } from "@nova/data-create-polygon-kml"
import { FeatureCollection } from "geojson"
export const polygonTransformer = (
    polygons: { name: string; points: Point[] }[],
    projection?: string
) => {
    const json = { type: "FeatureCollection", features: [] } as FeatureCollection
    polygons.forEach((polygon) => {
        json.features.push({
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    polygon.points.map((point) => projectToCRS([point[0], point[1]], projection)),
                ],
            },
            properties: {
                id: polygon.name,
            },
        })
    })
    return json
}
